module.exports = __webpack_public_path__ + "img/setdash.83eef7dd.svg";